import { render, staticRenderFns } from "./departmentcompany.vue?vue&type=template&id=7146ddfb&"
import script from "./departmentcompany.vue?vue&type=script&lang=js&"
export * from "./departmentcompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports